import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  AssetFinanceApplication,
  ApplicationSelectionType,
  PpsrAssetValue,
  PayloadApiResponse,
  PpsrAsset,
  VehicleDetails,
  calculateAssetFinanceEstimation,
  PaymentFrequencyType,
  AssetConditionType,
  SendContractEmailsFn,
  GetContractStatusFn,
  GenerateContractFn,
  DeleteContractFileFn,
  GetActiveContractForApplicationFn,
  ContractDetails,
  DeclineContractFn,
  getApplicationAssetCategory,
  FinanceType,
  RatecardDetails,
  constants,
  CreateApplicationNoteFn,
  AssetSettlementGetApplicationAssetFn,
  DigitalIdGetApplicationIndividualsFn,
  GetRateCardDetailsFn,
  getApplicationStage,
  applicationStageAllowGenerateContract,
  CreateNewDisbursementFn,
  UpdateDisbursementFn,
  GetDisbursementByApplicationIdFn,
  SyncDisbursementToSfFn,
  getBrokerageAmount,
  SyncBankDetailsToSfFn,
  SyncContractDetailsToSfFn,
  getBalloonPayment,
  getPaymentType,
  RemoveApplicationNoteByNoteIdFn,
  getAssetGoodRetail,
  GetBillerNameFn,
  ValidateBPAYFn,
  UpdateApplicationStageInSfFn,
  AzureStorageDocument,
  GroupedDocument,
  ApiResponse,
  GetApplicationByIdFn,
  Application,
  applicationStageAllowSettleLoan,
  SettleLoanFn,
  Disbursement,
  validateDisbursementData,
  SyncPrivateSellerBankDetailsToSfFn,
  GetInstitutionNameFn,
  SyncDepositPaidToSfFn,
  GenerateApprovalNoticeFn,
  SendApprovalNoticeEmailFn,
  DeleteApprovalNoticeFileFn,
  RefreshBankStatementFn,
  GetUserFn,
  GetAccountDetailsFromSfFn,
  GetBankDetailsFromOpportunitySfFn,
  LocalBankAccountDetailValue,
  ExtractTaxInvoiceFn,
  UpdateApplicationFn,
  getCreditRateAdjustment,
  CreateAssetInspectionFn,
  GetAssetInspectionsForApplicationFn,
  DownloadVerimotoReportFn,
  VerimotoInspectionTableDataWithInspectionDetails,
  VerimotoLenderType,
  UpdateApplicationSfFn,
  isAdminOrCreditUserOrSalesAM,
  TotalPaymentBreakupDialogData,
  GetDscrCalculatorValueFn,
  UpdateDscrCalculatorValueFn,
  VerimotoInspectionTypeSelection,
  GetBankStatementsAnalysisFn,
  getDocFee,
  validateAssetDeposits, validateAssetDepositAgainstApplicationDeposit,
  DownloadDocumentFromAzureFn,
  UpdateLvrCalculatorValueFn,
  GetLvrCalculatorValueFn,
  GetBsaLenderListFn,
  GetBsaExcludedLenderListFn,
  SaveBsaCalculatorFn,
  GetBsaCalculatorFn,
  RunCreditFlowFn,
  GetDscrCalculatorHistoryFn,
  GetBasiqCustomerMappingFn,
  GetBasiqStatementDataForCompanyFn,
  RefreshBasiqConnectionsFn,
  GetBankStatementAndBasiqDataStatusFn,
  GetOriginatorBusinessByIdFn,
  AddAuditLogFn,
  GetCreditWebServicesFn,
  GetApplicationCreditFlowResultFn,
  DownloadCreditorWatchReportFn,
  UpdateCreditStatusFn,
  GetCreditAuditLogFn,
  GetWebServiceReportFn,
  GetDuplicatedApplicationsFn,
  DuplicatedApplication,
  DeleteWebServicesFn,
  getRepaymentType,
  RequestMoreInformationFn,
  WithdrawApplicationFn,
  isAdminOrCreditUser,
  ApplicationSelectionObject,
  GetApplicationDscrFn,
  UpdateCreditOfficerFn,
  GetActiveCreditUsersFn,
  ResendContractFn,
  GetUserByAccessLevelFn,
  AggregatorAndOriginatorListValueGetFn,
  GetApplicationSettlementsOfficerFn,
  GetAmlOfficerCandidatesFn,
  NewWebService,
  // validateAssetDepositAgainstApplicationDeposit, validateAssetDeposits,
} from '@portal-workspace/grow-shared-library';
import {AmortisationScheduleEntry} from '@portal-workspace/grow-shared-library';
import {AmortizationChartData} from '@portal-workspace/grow-shared-library';
import {PaymentChartData} from '@portal-workspace/grow-shared-library';
import {RepaymentEstimationEntry} from '@portal-workspace/grow-shared-library';
import {
  ApplicationDialogService,
  ApproveApplicationDocumentFn,
  AssetSettlementAddPpsrDetailFn,
  AssetSettlementGetApplicationPpsrInfoFn,
  AssetSettlementGetPpsrDetailsFn,
  AssetSettlementGetPpsrDocumentsFn,
  AssetSettlementRemoveApplicationAssetFn,
  // AssetSettlementSavePpsrDocumentFn,
  AssetSettlementSearchAssetsFn,
  AssetSettlementSearchGrantorsFn,
  AssetSettlementSendAssetToSfFn,
  AssetSettlementSubmitApplicationAssetsFn,
  AssetSettlementSubmitPpsrFn,
  AssetSettlementUpdateApplicationAssetsFn,
  AssetSettlementUpdatePpsrDetailFn,
  BusinessSearchFn,
  CompleteDocumentWorklistFn,
  CreateDocumentWorklistFn,
  DeclineApplicationDocumentFn,
  DeleteApplicationDocumentFn,
  DigitalIdAddIndividualFn,
  DigitalIdSendVerificationSmsFn,
  DigitalIdUpdateApplicationIndividualDigitalIdMappingFn,
  SaveApplicationPartiesFn,
  DigitalIdVerifyOneApplicationIndividualFn,
  GetOriginatorByIdFn,
  getUser,
  PortalHotToastService,
  ListApplicationDocumentFn,
  DownloadAllApplicationDocumentUrlFn, DownloadApplicationDocumentUrlFn,
  SaveSupplierFn,
  SearchSupplierFn,
  UpdateApplicationDocumentTagsFn,
  UpdateApplicationRequiredDocumentsFn,
  BusinessNumberSearchFn,
  applicationDefaultDocuments,
  UndoApplicationDocumentFn, AssetSelectionComponentSearchFn, applicationToTransactionValue,
  applicationToEquifaxDirectorScoreMeetsThreshold,
  DscrCalculatorComponent,
} from '@portal-workspace/grow-ui-library';
import { LvrCalculatorComponent } from '../lvr-calculator.component';
import {
  yesNoToBoolean,
  isInternalUser,
  DocumentTag,
  DigitalIdUpdateIndividualKycStatusFn,
  DigitalIdSyncIndividualKycFromFrankieOneFn,
} from '@portal-workspace/grow-shared-library';
import { BreadcrumbComponentEvent, BreadcrumbComponent } from '../../breadcrumb-component/breadcrumb.component';
import moment from 'moment';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Observable, Subscription, combineLatest, of, catchError} from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';
import {setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {
  getAbn,
  getAcn,
  getAdverseOnFile,
  getApplicationNotes, getAssetCondition,
  getAssetDescription,
  getAssetFamily,
  getAssetCategoryObj,
  getAssetSpec,
  getAssetTypeObj,
  getAssetMake, getAssetNewPrice,
  getAssetType, getAssetYear, getBalloonPaymentPercentage,
  getBrokerage,
  getBrokerApplicationId,
  getBrokerName, getBrokerOriginationFee,
  getBrokerSalesforceId,
  getAppSalesforceId,
  getCompanyName,
  getDeposit,
  getDocFeeFinanced,
  getEquifaxScoreAboveThresold,
  getFinanceType,
  getIndustrySector,
  getInterestRate,
  getInvoiceAmount,
  getLoanAmount,
  getLoanTerms,
  getOrganisationType, getPrimaryBusinessAddress,
  getPrivateSales,
  applicationEntityDisplayName,
  getPropertyOwner,
  getRepaymentFrequency,
  getRevenue,
  formGroupedDocumentData,
  unclassifiedDocuments,
  groupStandardCondition,
  GetHistoricalContractsFn,
  GetPismoContractsFn,
} from '@portal-workspace/grow-shared-library';
import { User } from '@portal-workspace/grow-shared-library';
import {UpdateApplicationDocumentFn} from '../application-details.module';
import {GetUsersByOriginatorBusinessIdFunc, UserSelectionComponentEvent} from '@portal-workspace/grow-ui-library';
import {GetApplicationAuditLogsFn} from '@portal-workspace/grow-ui-library';
import {GetNotesByApplicationIdFn} from '@portal-workspace/grow-ui-library';
import {UpdateDocumentMetadataFn} from '@portal-workspace/grow-ui-library';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import { AssetDocumentsComponent } from './asset-documents.component';
import { KycVerificationComponent } from '../kyc-verification.component';
import { confirmLeaveKycAmlTab } from '../kyc-unsaved-tab-guard';
import { AddAssetComponent } from '../../asset-listing-component/add-asset.component';
import { AssetSettlementComponent } from './asset-settlement.component';
import { AssetAppComponent } from './asset-app.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import {MatTabChangeEvent, MatTabsModule} from '@angular/material/tabs';
import { ApplicationStageIconComponent } from '../application-stage-icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import {AssetPricingComponent, AssetPricingComponentEvent} from "./asset-pricing.component";
import {AssetCreditComponent} from './asset-credit.component';
import { MatExpansionModule } from "@angular/material/expansion";
import {ApplicationTypeIconComponent} from '../../application-type-icon/application-type-icon.component';
import { CreditReportComponent } from '../../credit-component/credit-report.component';
import { BankStatementComponent } from '../../bank-statement-component/bank-statement.component';
import { BasiqStatementComponent } from '../../basiq-statement-component/basiq-statement.component';
import { BankComponent } from '../bank.component';
import { ActivatedRoute } from '@angular/router';


export type AssetTab = {selectionTypes: ApplicationSelectionType[], iconClass: string, name: string, index: number};

@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
    selector: 'asset-finance-application-details',
    templateUrl: './asset-finance-application-details.component.html',
    styleUrls: ['./asset-finance-application-details.component.scss'],
    standalone: true,

  imports: [
    AssetCreditComponent,
    FlexModule,
    DscrCalculatorComponent,
    MatExpansionModule,
    BreadcrumbComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltipModule,
    ApplicationStageIconComponent,
    MatTabsModule,
    MatMenuModule,
    MatDividerModule,
    AssetAppComponent,
    MessageBoxComponent,
    AssetSettlementComponent,
    AddAssetComponent,
    KycVerificationComponent,
    AssetDocumentsComponent,
    AssetPricingComponent,
    BankStatementComponent,
    LvrCalculatorComponent,
    ApplicationTypeIconComponent,
    CreditReportComponent,
    BasiqStatementComponent,
    BankComponent
  ]
})
export class AssetFinanceApplicationDetailsComponent implements OnInit {

  tabs: AssetTab[] = [];
  ratecard: RatecardDetails | null = null;

  // possible selections that can be access directly through URL
  possibleSelections: ApplicationSelectionType[] = ['app', 'quote', 'bank-statement', 'asset', 'documents','credit' ,'add-asset', 'kyc-aml', 'pricing', 'credit-report'];

  breadcrumbTrails: string[] = ['Applications'];

  @Input() getApplicationPpsrInfoFn!: AssetSettlementGetApplicationPpsrInfoFn;
  @Input() removeApplicationAssetFn!: AssetSettlementRemoveApplicationAssetFn;
  @Input() searchAssetFn!: AssetSettlementSearchAssetsFn;
  @Input() submitPpsrFn!: AssetSettlementSubmitPpsrFn;
  @Input() getApplicationAssetFn!: AssetSettlementGetApplicationAssetFn;
  @Input() sendAssetToSfFn!: AssetSettlementSendAssetToSfFn;
  @Input() getPpsrDetailsFn!: AssetSettlementGetPpsrDetailsFn;
  @Input() addPpsrDetailFn!: AssetSettlementAddPpsrDetailFn;
  @Input() updatePpsrDetailFn!: AssetSettlementUpdatePpsrDetailFn;
  @Input() updateApplicationAssetsFn!: AssetSettlementUpdateApplicationAssetsFn;
  @Input() submitApplicationAssetsFn!: AssetSettlementSubmitApplicationAssetsFn;
  @Input() searchGrantorsFn!: AssetSettlementSearchGrantorsFn;
  @Input() getPpsrDocumentsFn!: AssetSettlementGetPpsrDocumentsFn;
  @Input() assetSearchFn!: AssetSelectionComponentSearchFn;
  @Input() getOriginatorByIdFn!: GetOriginatorByIdFn;
  @Input() addIndividualFn!: DigitalIdAddIndividualFn;
  @Input() verifyOneApplicationIndividualFn!: DigitalIdVerifyOneApplicationIndividualFn;
  @Input() sendVerificationSmsFn!: DigitalIdSendVerificationSmsFn;
  @Input() getApplicationIndividualsFn!: DigitalIdGetApplicationIndividualsFn;
  @Input() saveApplicationPartiesFn!: SaveApplicationPartiesFn;
  @Input() updateApplicationIndividualDigitalIdMappingFn!: DigitalIdUpdateApplicationIndividualDigitalIdMappingFn;
  @Input() searchSupplierFn!: SearchSupplierFn;
  @Input() saveSupplierFn!: SaveSupplierFn;
  @Input() businessSearchFn!: BusinessSearchFn;
  @Input() downloadDocumentFromAzureFn!: DownloadDocumentFromAzureFn;
  @Input() apiUrl!: string;
  @Input() defaultSalesContactId!: string;
  @Input() onBreadcrumbEventsFn: (evt: BreadcrumbComponentEvent)=>void = (evt)=>{};
  @Input() listApplicationDocumentFn!: ListApplicationDocumentFn;
  @Input() downloadApplicationDocumentUrlFn!: DownloadApplicationDocumentUrlFn;
  @Input() approveApplicationDocumentFn!: ApproveApplicationDocumentFn;
  @Input() declineApplicationDocumentFn!: DeclineApplicationDocumentFn;
  @Input() deleteApplicationDocumentFn!: DeleteApplicationDocumentFn;
  @Input() downloadAllApplicationDocumentUrlFn!: DownloadAllApplicationDocumentUrlFn;
  @Input() updateApplicationDocumentTagsFn!: UpdateApplicationDocumentTagsFn;
  @Input() updateApplicationRequiredDocumentsFn!: UpdateApplicationRequiredDocumentsFn;
   
  @Input() createDocumentWorklistFn!: CreateDocumentWorklistFn;
  @Input() completeDocumentWorklistFn!: CompleteDocumentWorklistFn;
  @Input() getBankStatementsAnalysisFn!: GetBankStatementsAnalysisFn;
  @Input({required: true}) getBankStatementAndBasiqDataStatusFn!: GetBankStatementAndBasiqDataStatusFn;
  @Input({required: true}) getBasiqCustomerMappingByAbnFn!: GetBasiqCustomerMappingFn;
  @Input({required: true}) getBasiqStatementDataForCompanyFn!: GetBasiqStatementDataForCompanyFn;
  @Input({required: true}) refreshBasiqConnectionsFn!: RefreshBasiqConnectionsFn;

  @Input() createApplicationNoteFn!: CreateApplicationNoteFn;
  @Input() removeApplicationNoteByNoteIdFn!: RemoveApplicationNoteByNoteIdFn;
  @Input() getApplicationAuditLogsFn!: GetApplicationAuditLogsFn;
  @Input() getNotesByApplicationIdFn!: GetNotesByApplicationIdFn;
  @Input() assetSettlementSearchAssetsFn!: AssetSettlementSearchAssetsFn;
  @Input() sendContractEmailsFn!: SendContractEmailsFn;
  @Input() updateDocumentMetadataFn!: UpdateDocumentMetadataFn;
  @Input() assetSettlementSearchGrantorsFn!:AssetSettlementSearchGrantorsFn;
  @Input() getContractStatusFn!: GetContractStatusFn;
  @Input() generateContractFn!: GenerateContractFn;
  @Input() deleteContractFileFn!: DeleteContractFileFn;
  @Input() createNewDisbursementFn!: CreateNewDisbursementFn;
  @Input() updateDisbursementFn!: UpdateDisbursementFn;
  @Input() getDisbursementByApplicationIdFn!: GetDisbursementByApplicationIdFn;
  @Input() syncDisbursementToSfFn!: SyncDisbursementToSfFn;
  @Input() syncBankDetailsToSfFn!: SyncBankDetailsToSfFn;
  @Input() syncPrivateSellerBankDetailsToSfFn!: SyncPrivateSellerBankDetailsToSfFn;
  @Input() syncDepositPaidToSfFn!: SyncDepositPaidToSfFn;
  @Input() syncContractDetailsToSfFn!: SyncContractDetailsToSfFn;
  @Input() businessNumberSearchFn!: BusinessNumberSearchFn;
  @Input() updateApplicationStageFn!: UpdateApplicationStageInSfFn;
  @Input() getApplicationByIdFn!: GetApplicationByIdFn;
  @Input() settleLoanFn!: SettleLoanFn;
  @Input() allowContractGeneration!: boolean;
  @Input() generateApprovalNoticeFn!: GenerateApprovalNoticeFn;
  @Input() sendApprovalNoticeEmailFn!: SendApprovalNoticeEmailFn;
  @Input() deleteApprovalNoticeFileFn!: DeleteApprovalNoticeFileFn;
  @Input() undoApplicationDocumentFn!: UndoApplicationDocumentFn;
  @Input() refreshBankStatementFn!: RefreshBankStatementFn;
  @Input() getAccountDetailsFromSfFn!: GetAccountDetailsFromSfFn;
  @Input() getBankDetailsFromOpportunitySfFn!: GetBankDetailsFromOpportunitySfFn;
  @Input() extractTaxInvoiceFn!: ExtractTaxInvoiceFn;
  @Input() updateApplicationFn!: UpdateApplicationFn;
  @Input() updateApplicationSfFn!: UpdateApplicationSfFn;
  @Input() createAssetInspectionFn!: CreateAssetInspectionFn;
  @Input() getAssetInspectionsForApplicationFn!: GetAssetInspectionsForApplicationFn;
  @Input() downloadVerimotoReportFn!: DownloadVerimotoReportFn;
  @Input() verimotoLender!: VerimotoLenderType;
  @Input() verimotoAssetInspectionTypes!: VerimotoInspectionTypeSelection[];
  @Input({required: true}) updateLvrCalculatorValueFn!: UpdateLvrCalculatorValueFn;
  @Input({required: true}) getLvrCalculatorValueFn!: GetLvrCalculatorValueFn;
  @Input({required: true}) getBsaLenderListFn!: GetBsaLenderListFn;
  @Input({required: true}) getBsaExcludedLenderListFn!: GetBsaExcludedLenderListFn;
  @Input({required: true}) saveBsaCalculatorFn!: SaveBsaCalculatorFn;
  @Input({required: true}) getBsaCalculatorFn!: GetBsaCalculatorFn;
  @Input({required: true}) runCreditFlowFn!: RunCreditFlowFn;
  @Input({required: true}) getCreditWebServicesFn!: GetCreditWebServicesFn;
  @Input({required: true}) downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  @Input({required: true}) getApplicationCreditFlowResultFn!: GetApplicationCreditFlowResultFn;
  @Input({required: true}) updateCreditStatusFn!: UpdateCreditStatusFn;
  @Input({required: true}) updateCreditOfficerFn!: UpdateCreditOfficerFn;
  @Input({required: true}) getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  @Input({required: true}) getCreditAuditLogFn!: GetCreditAuditLogFn;
  @Input({required: true}) getDscrCalculatorHistoryFn!: GetDscrCalculatorHistoryFn;
  @Input({required: true}) getOriginatorBusinessByIdFn!: GetOriginatorBusinessByIdFn;
  @Input({required: true}) addAuditLogFn!: AddAuditLogFn;
  @Input({required: true}) getWebServiceReportFn!: GetWebServiceReportFn;
  @Input({required: true}) getDuplicatedApplicationsFn!: GetDuplicatedApplicationsFn;
  @Input({required: true}) deleteWebServicesFn!: DeleteWebServicesFn;
  @Input({required: true}) requestMoreInformationFn!: RequestMoreInformationFn;
  @Input({required: true}) withdrawApplicationFn!: WithdrawApplicationFn;
  @Input({required: true}) getApplicationDscrFn!: GetApplicationDscrFn;
  @Input({required: true}) resendContractFn!: ResendContractFn;
  @Input({required: true}) getAggregatorsAndOriginatorsFn!: AggregatorAndOriginatorListValueGetFn;
  @Input({required: true}) getUserByAccessLevelFn!: GetUserByAccessLevelFn;
  @Input({required: true}) getApplicationSettlementsOfficerFn!: GetApplicationSettlementsOfficerFn;
  @Input() getAmlOfficerCandidatesFn?: GetAmlOfficerCandidatesFn;
  @Input({required: true}) getHistoricalContractsFn!: GetHistoricalContractsFn;
  @Input({required: true}) getPismoContractsFn!: GetPismoContractsFn;
  @Input({required: true}) updateIndividualKycStatusFn!: DigitalIdUpdateIndividualKycStatusFn;
  @Input() syncIndividualKycFromFrankieOneFn?: DigitalIdSyncIndividualKycFromFrankieOneFn;

  @Output() navigateToApplications = new EventEmitter();
  @Output() assetPricingEvents = new EventEmitter<AssetPricingComponentEvent>();
  @Output() refreshCreditTabEvent = new EventEmitter<Application>;

  repaymentEstimationData: RepaymentEstimationEntry[] = [];
  amortizationScheduleData: AmortisationScheduleEntry[] = [];
  rst!: TotalPaymentBreakupDialogData
  isAssetEmpty: boolean = false;
  paymentChartData: PaymentChartData = {
    amountFinanced: 0,
    totalInterest: 0,
    emiAmt: 0,
    paymentFrequency: 'Monthly',
    principalAmt: 0,
    interestAmt: 0,
    totalAmt: 0,
    loanTerm: 0,
    lvr: 0,
    rv: 0,
    brokerageAmount: 0,
    docFee: 0,
    brokerOriginationFee: 0,
    applicationType: 'AssetFinance'
  };
  amortizationChartData: AmortizationChartData = {
    estimatedDrawdownDate: moment(),
    annualData: [],
    quarterlyData: [],
  };
  calculationLog?: {log: string, rate?: number}[];

  isInternalUser = isInternalUser;
  isAdminOrCreditUserOrSalesAM = isAdminOrCreditUserOrSalesAM;
  isAdminOrCreditUser = isAdminOrCreditUser;
  getCompanyName = getCompanyName;
  getBrokerApplicationId = getBrokerApplicationId;
  getBrokerSalesforceId = getBrokerSalesforceId;
  getAppSalesforceId = getAppSalesforceId;
  getBrokerName = getBrokerName;
  getOrganisationType = getOrganisationType;
  getInterestRate = getInterestRate;
  getLoanAmount = getLoanAmount;
  getBrokerage = getBrokerage;
  getAbn = getAbn;
  getAcn = getAcn;
  getFinanceType = getFinanceType;
  getApplicationAssetCategory = getApplicationAssetCategory;
  getAssetType = getAssetType;
  getAssetMake = getAssetMake;
  getAssetFamily = getAssetFamily;
  getAssetYear = getAssetYear;
  getAssetDescription = getAssetDescription;
  getAssetCondition = getAssetCondition;
  getInvoiceAmount = getInvoiceAmount;
  getLoanTerms = getLoanTerms;
  getPrivateSales = getPrivateSales;
  getEquifaxScoreAboveThreshold = getEquifaxScoreAboveThresold;
  getAdverseOnFile = getAdverseOnFile;
  getPropertyOwner = getPropertyOwner;
  getDocFeeFinanced = getDocFeeFinanced;
  getRepaymentFrequency = getRepaymentFrequency;
  getDeposit = getDeposit;
  getRevenue = getRevenue;
  getIndustrySector = getIndustrySector;
  getApplicationNotes = getApplicationNotes;
  getPrimaryBusinessAddress = getPrimaryBusinessAddress;
  getApplicationStage = getApplicationStage;
  applicationStageAllowGenerateContract = applicationStageAllowGenerateContract;
  getPaymentType = getPaymentType;
  formGroupedDocumentData = formGroupedDocumentData;
  unclassifiedDocuments = unclassifiedDocuments;
  applicationStageAllowSettleLoan = applicationStageAllowSettleLoan;
  groupStandardCondition = groupStandardCondition;
  @Input() uploadApplicationDocumentFn!: UpdateApplicationDocumentFn;
  @Input() getRatecardDetailsFn!: GetRateCardDetailsFn;
  @Input() getUsersInCompanyFn!: GetUsersByOriginatorBusinessIdFunc;
  @Input() getActiveContractForApplicationFn!: GetActiveContractForApplicationFn;
  @Input() declineContractFn!: DeclineContractFn;
  @Input() getBillerNameFn!: GetBillerNameFn;
  @Input() getInstitutionNameFn!: GetInstitutionNameFn;
  @Input() validateBpayFn!: ValidateBPAYFn;
  @Input() bankStatementsUrl!: string;
  @Input() getUserFn!: GetUserFn;
  @Output() events = new EventEmitter<UserSelectionComponentEvent & {type: 'submitter' | 'additional-correspondent' | 'broker' | 'sales-contact' | 'credit-officer' | 'settlement' | 'aml-officer'}>();
  @Input({required: true}) getDscrCalculatorValueFn!: GetDscrCalculatorValueFn;
  @Input({required: true}) updateDscrCalculatorValueFn!: UpdateDscrCalculatorValueFn;

  sendToSF: boolean = false;

  editAssetValue!: PpsrAssetValue
  registered: boolean = false;
  ppsrChecked!: boolean;
  ppsrRegistered!: boolean;
  currentSection: ApplicationSelectionType = 'app';
  currentSectionIndex = 0;
  assetStatus:PpsrAsset[]=[];
  subscriptions: Subscription[] = [];
  loggedInUser: User | null = getUser();
  disableAddAsset: boolean = false
  notAllAssetAccepted: boolean = false;
  activeContract: ContractDetails | null = null;
  missingBankDetails: null | 'customer' | 'broker' = null;
  assetInspectionTableData: VerimotoInspectionTableDataWithInspectionDetails[] = [];
  @Input() application!: AssetFinanceApplication;
  @Input() initialSelection: ApplicationSelectionType = 'app';
  @Output() selectionEvent: EventEmitter<ApplicationSelectionObject> = new EventEmitter<ApplicationSelectionObject>();
  @Output() clickApplicationEvent = new EventEmitter<DuplicatedApplication>;

  @ViewChild(KycVerificationComponent) kycVerification?: KycVerificationComponent;

  constructor(private toastService: PortalHotToastService,
    private dialogService: ApplicationDialogService,
    private applicationDialogService: ApplicationDialogService,
    private activatedRoute: ActivatedRoute,
  ) {}

  initTabs() {
    this.tabs = [];
    this.tabs.push({selectionTypes: ['app'], iconClass: 'mdi-view-grid-outline', name: 'APPLICATION', index: (this.tabs.length)});
    this.tabs.push({ selectionTypes: ['bank-statement'], iconClass: 'mdi-bank-outline', name: 'BANK STATEMENTS', index: (this.tabs.length) });
    this.tabs.push({selectionTypes: ['kyc-aml'], iconClass: 'mdi-check-decagram-outline', name: 'CUSTOMER DETAILS(KYC/AML)', index:(this.tabs.length)});
    if (isInternalUser(this.loggedInUser)) {
      this.tabs.push({selectionTypes: ['credit', 'credit-report'], iconClass: 'mdi-calculator', name: 'CREDIT', index: (this.tabs.length)});
    }
    this.tabs.push({selectionTypes: ['documents'], iconClass: 'mdi-folder-outline', name: 'DOCUMENTS', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['asset', 'add-asset'], iconClass: 'mdi-handshake-outline', name: 'CONTRACT', index: (this.tabs.length)});
    if (isAdminOrCreditUserOrSalesAM(this.loggedInUser) || isInternalUser(this.loggedInUser)) {
      this.tabs.push({selectionTypes: ['pricing'], iconClass: 'mdi-currency-usd', name: 'PRICING', index: (this.tabs.length)});
    }
  }

  hasUnsavedKycChanges(): boolean {
    return this.currentSection === 'kyc-aml' && !!this.kycVerification?.hasUnsavedChanges();
  }

  unsavedKycChangeLabels(): string[] {
    return this.kycVerification?.unsavedChangeLabels() ?? [];
  }

  async onSelectedTabChange(event: MatTabChangeEvent) {
    const previousSection = this.currentSection;
    const tabFound = this.tabs.find(t => t.index == event.index);
    const selection = tabFound ? tabFound.selectionTypes[0] : 'app' /* default selection if not found */ ;
    const canLeave = await confirmLeaveKycAmlTab({
      previousSection,
      nextSection: selection,
      kycVerification: this.kycVerification,
      dialogService: this.dialogService,
      revertToKycTab: () => {
        const kycTab = this.tabs.find(t => t.selectionTypes.includes('kyc-aml'));
        if (kycTab) {
          this.currentSectionIndex = kycTab.index;
        }
      },
    });
    if (!canLeave) {
      return;
    }
    this.currentSection = selection;
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  showAddAsset() {
    this.currentSection = 'add-asset';
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  onViewReport(element: NewWebService) {
    this.currentSection = 'credit-report';
    console.log(this.currentSection)
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: String(element.id),
    });
  }

  onLeaveReport(event: void) {
    this.currentSection = 'credit';
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  async ngOnInit() {
    this.initTabs();

    const routeTab = this.initialSelection;
    if (routeTab && this.possibleSelections.includes(routeTab)) {
      const _tab = this.tabs.find(tab => tab.selectionTypes.includes(routeTab));
      if (_tab) {
        this.currentSection = routeTab;
        this.currentSectionIndex = _tab.index;
      }
    }
    setupUntilDestroy(this);
    const user = this.loggedInUser;
    const entityName = applicationEntityDisplayName(this.application);
    if (entityName) {
      this.breadcrumbTrails.push(entityName);
    }

    const sub = this.getRatecardDetailsFn(this.application.UserId, 'AssetFinance').pipe(
      tap((r: RatecardDetails) => {
        this.ratecard = r;
        this.recalculateEstimation();
      })
    ).subscribe();

    this.subscriptions.push(this.assetPricingEvents.subscribe((evt) => {
      switch(evt.type) {
        case "asset-pricing-saved": {
          this.rst = evt.rst.totalPaymentBreakupDialogData;
          this.repaymentEstimationData = evt.rst.totalPaymentBreakupDialogData.repaymentEstimationData;
          this.amortizationChartData = evt.rst.totalPaymentBreakupDialogData.amortizationChartData;
          this.paymentChartData = evt.rst.totalPaymentBreakupDialogData.paymentChartData;
          this.amortizationChartData = evt.rst.totalPaymentBreakupDialogData.amortizationChartData;
          break;
        }
      }
    }));

    this.subscriptions.push(sub);
    this.getApplicationAsset();
    this.getActiveContract();
    this.getBankDetails();
    this.loadAssetInspections();
  }

  recalculateEstimation() {
    if (this.ratecard) {
      const r = this.ratecard;
      const assetSpec = getAssetSpec(this.application);
      const assetGoodRetail = getAssetGoodRetail(this.application);
      const assetNewPrice = getAssetNewPrice(this.application);
      const assetCategory = getApplicationAssetCategory(this.application); // as string
      const assetType = getAssetType(this.application); // as string
      const ac = getAssetCategoryObj(this.application);
      const at = getAssetTypeObj(this.application);

      const date = moment().add(1, 'day');

      const financialType = (getFinanceType(this.application) as string).toLowerCase().split(' ').join('-') as FinanceType;
      const rst = calculateAssetFinanceEstimation(date, {
        type: 'AssetFinance',
        paymentFrequencyType: getRepaymentFrequency(this.application) ? getRepaymentFrequency(this.application) as PaymentFrequencyType : 'Monthly',
        assetConditionType: getAssetCondition(this.application) as AssetConditionType ?? null,
        assetSelectionValue: {
          ...{
            make: assetSpec?.make,
            family: assetSpec?.family,
            year: assetSpec?.year ? String(assetSpec.year) : '',
            vehicle:  {
              goodretail: assetGoodRetail,
              newprice: assetNewPrice,
            },
            LVR: assetSpec?.LVR,
            description: assetSpec?.description ?? '',
            avgRetail: assetSpec?.avgretail,
            newPrice: assetSpec?.newPrice,
            OtherCar: assetSpec?.OtherCar ?? false,
            truckGrossVehicleWeight:  assetSpec?.truckGrossVehicleWeight,
          },
          category: ac ?? {index: assetCategory, value: assetCategory},
          type: at ?? { index: assetType, value: assetType }
        }, // as AssetSelectionComponentValue,
        assetYear: parseFloat(getAssetYear(this.application) != '' ? getAssetYear(this.application) as any :  "0"),
        loanTerm: getLoanTerms(this.application),
        financeType: financialType,
        loanAmount: getLoanAmount(this.application),
        businessSearchValue: null,
        existingApplicationBureauReport: this.application.CompanyDetails,
        propertyOwnership: yesNoToBoolean(getPropertyOwner(this.application)),
        docFeeFinanced: yesNoToBoolean(getDocFeeFinanced(this.application)),
        brokerOriginationFee: getBrokerOriginationFee(this.application),
        brokerage: getBrokerage(this.application),
        adverseOnFile: yesNoToBoolean(getAdverseOnFile(this.application)),
        equifaxDirectorScoreMeetsProductThreshold: yesNoToBoolean(getEquifaxScoreAboveThresold(this.application)),
        equifaxDirectorScoreAbove700: applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=700'),
        privateSaleOrLeaseback: getPrivateSales(this.application) !== 'No',
        balloonPayment: getBalloonPaymentPercentage(this.application),
        balloonPaymentAmount: getBalloonPayment(this.application),
        docFee: getDocFee(this.application) as number,
        rateCard: r,
        invoiceAmount: Number(getInvoiceAmount(this.application)),
        deposit: Number(getDeposit(this.application)),
        brokerageAmount: this.application.PricingDetails?.BrokerageAmount ? getBrokerageAmount(this.application) : undefined,
        paymentType: String(getPaymentType(this.application)),
        creditRateAdjustment: getCreditRateAdjustment(this.application),
        transactionType: applicationToTransactionValue(this.application)?.type,
        repaymentType: getRepaymentType(this.application)
      });

      this.rst = rst.totalPaymentBreakupDialogData
      this.repaymentEstimationData = rst.totalPaymentBreakupDialogData.repaymentEstimationData;
      this.amortizationScheduleData = rst.totalPaymentBreakupDialogData.amortizationScheduleData;
      this.paymentChartData = rst.totalPaymentBreakupDialogData.paymentChartData;
      this.amortizationChartData = rst.totalPaymentBreakupDialogData.amortizationChartData;
      this.calculationLog = rst.totalPaymentBreakupDialogData.calculationLog;
    }

  }

  loadAssetInspections() {

    console.log('============on inscpection created')
    this.subscriptions.push(
      this.getAssetInspectionsForApplicationFn(this.application.ApplicationId).pipe(
      ).subscribe((data: VerimotoInspectionTableDataWithInspectionDetails[]) => {
        console.log('===asset inspections: ', data);
        this.assetInspectionTableData = data;
      })
    )
  }

  onBreadcurmbEvents($event: BreadcrumbComponentEvent) {
    this.onBreadcrumbEventsFn($event);
  }

  getApplicationAsset() {
    this.subscriptions.push(
      this.getApplicationAssetFn(this.application.ApplicationId).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe((res: PpsrAsset[]) => {
        const stageName = this.application.AppInfoStageName
        if (res.length) {
          if(stageName == 'Closed Won' || stageName == 'Settlement') {
            this.disableAddAsset = false
          }
          this.assetStatus = res.filter(r => r.status === 'accepted');
          if (res.length !== this.assetStatus.length) {
            this.notAllAssetAccepted = false
          }
          else {
            this.notAllAssetAccepted = true
          }
        } else {
          this.disableAddAsset = false;
        }
      })
    )
  }

  getEvent() {
    this.currentSection = "asset"
    this.editAssetValue = null;
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  getAssetSave() {
    this.currentSection = "asset"
    this.editAssetValue = null;
    this.isAssetEmpty = false;
    // if current stage is credit approved, change the stage to deal prep
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  getBankDetails() {
    if (this.application.AppInfo.BrokerSalesforceID && this.application.AppInfo.CustomerId) {
      this.subscriptions.push(
        combineLatest([
          this.getAccountDetailsFromSfFn(this.application.AppInfo.BrokerSalesforceID ?? "0"),
          this.getAccountDetailsFromSfFn(this.application.AppInfo.CustomerId ?? "0"),
        ]).pipe(
          switchMap(([brokerBankDetails, customerBankDetails]: [LocalBankAccountDetailValue, LocalBankAccountDetailValue]) => {
            console.log('brokerBankDetails, customerBankDetails: ', brokerBankDetails, customerBankDetails)
            this.missingBankDetails = null;
            if (!brokerBankDetails?.AccountNumber || !brokerBankDetails?.BSB || !brokerBankDetails.AccountName) {
              this.missingBankDetails = 'broker';
              return of(null);
            } else if (!customerBankDetails?.AccountNumber || !customerBankDetails.BSB || !customerBankDetails.AccountName) {
              return this.getBankDetailsFromOpportunitySfFn(this.application.AppInfoSalesforceID ?? "");
            } else {
              return of(customerBankDetails);
            }
          })
        ).subscribe((result: LocalBankAccountDetailValue) => {
          if ((!result?.AccountNumber || !result?.BSB || !result?.AccountName) && this.missingBankDetails !== 'broker') {
            this.missingBankDetails = 'customer';
          }
          console.log('customer bank details on oppo level: ', result);
        })
      )
    }
  }

  onEditAssetEvent($event: PpsrAssetValue) {
    this.editAssetValue = $event;
    this.currentSection = 'add-asset'
  }
  onPPSRCheckAll(element: any) {
    let ppsrAsset: PpsrAsset[] = [];
    let ppsrError = false;

    this.applicationDialogService.openPPSRCheckDialog()
      .afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            this.getApplicationAssetFn(this.application.ApplicationId)
              .pipe(
                switchMap((res: PpsrAsset[]) => {
                  const subs = [];
                  for (let i = 0; i < res.length; i++) {
                    this.ppsrChecked = false;
                    if (res[i].SettlementAssetDetails?.serialNumber !== null && res[i].SettlementAssetDetails?.serialNumberType !== null && (res[i].PPSRStatus === 'unchecked' || res[i].PPSRStatus === 'issue') && res[i].SettlementAssetDetails?.assetCategory !== '141') {
                      ppsrAsset.push(res[i]);
                      subs.push(
                        this.assetSettlementSearchAssetsFn(this.application.ApplicationId, {
                          SearchNumber: res[i].SettlementAssetDetails?.serialNumber ,
                          NumberType: (res[i].SettlementAssetDetails?.serialNumberType as string).replace(/ +/g, ''),
                        })
                      )
                    }
                  }
                  if (!subs.length) {
                    return of([]);
                  }
                  return combineLatest(subs);
                }),
                this.toastService.spinnerObservable(),
                tap((results: (VehicleDetails | { Error: any } | null)[]) => {
                  if (!results || !results?.length) {
                    this.dialogService.openAlertDialog({
                      message: 'Warn',
                      subMessage: 'PPSR check is already done',
                    });
                  } else {
                    for (let i = 0; i < results.length; i++) {
                      const data = results[i];
                      if (data && (data as { Error: any })?.Error) {
                        let asset: any = {};
                        asset.AssetId = ppsrAsset[i].AssetId;
                        asset.PPSRStatus = 'issue';
                        this.updateAssetsToDatabase(asset, 'save')
                        ppsrError = true;
                      } else if (data && !(data as { Error: any })?.Error) {
                        let asset: any = {};
                        asset.AssetId = ppsrAsset[i].AssetId;
                        asset.SettlementAssetDetails = ({
                          ...ppsrAsset[i].SettlementAssetDetails,
                          VehicleDetails: data,
                        })
                        asset.PPSRStatus = 'confirmed';
                        this.updateAssetsToDatabase(asset, 'save')
                      }
                    }

                    if (ppsrError) {
                      this.dialogService.openAlertDialog({
                        message: 'Error',
                        subMessage: 'Please try after sometime',
                      });
                    } else {
                      this.dialogService.successDialog({
                        message: 'Success',
                        subMessage: 'PPSR check completed',
                      });
                    }
                  }
                })
              ).subscribe(() => { this.ppsrChecked = true; }) // refresh the table
          }
        })
      ).subscribe();
  }

  async updateAssetsToDatabase(assetUpdateData: PpsrAsset, key: string) {
    this.updateApplicationAssetsFn(assetUpdateData).pipe(
      this.toastService.spinnerObservable(),
      this.toastService.snackBarObservable('Asset Updated'),
      tap(r => {
      }
      )).subscribe();
  }

  onPPSRRegister() {
    this.applicationDialogService.openPPSRRegisterDialog()
      .afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            this.submitPpsrFn(this.application.ApplicationId).pipe(
              this.toastService.spinnerObservable(),
              tap(r => {
                const data: any = r
                if (!data || data.Error) {
                  this.dialogService.openAlertDialog({
                    message: 'Error',
                    subMessage: 'Please try after sometime',
                  });
                }
                else {
                  this.dialogService.successDialog({
                    message: 'Success',
                    subMessage: 'PPSR registration done',
                  });
                  console.log('***** submitPpsr response', r);
                }
              }),
              catchError(err => {
                console.log(`error submitPpsr`, err);
                this.dialogService.openAlertDialog({
                  message: 'Error',
                  subMessage: 'Please try after sometime',
                });
                return of(null);
              })
            ).subscribe();
          }
        })
      ).subscribe();
  }

  applicationDocumentTypes(application: Application) {
    const tags = application?.DocumentTypes?.length ? application?.DocumentTypes.map(t => {
      return {
        ...t,
        value: t.value.toLowerCase()
      }
    }) : [];
    const documentTypes: DocumentTag[] = [];
    for (const tag of tags) {
      if (!documentTypes.map(t => t.value).includes(tag.value)) {
        documentTypes.push(tag)
      }
    }
    return documentTypes;
  }

  onSettleLoan(){
    if (isInternalUser(this.loggedInUser)) {
      this.applicationDialogService.openSettleLoanDialog(true)
        .afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            this.doSendAssetAndDisbursementToSf();
          }
        })
      ).subscribe()
    } else {
      this.applicationDialogService.openSettleLoanDialog(false).afterClosed().pipe(
        tap(async (r) => {
          if (r) {
            // check documents first
            this.subscriptions.push(
              combineLatest([
                this.listApplicationDocumentFn(this.application.ApplicationId),
                this.getApplicationByIdFn(this.application.ApplicationId)
              ]).pipe(
                  this.toastService.spinnerObservable()
                ).subscribe(([r, app]: [AzureStorageDocument[], Application]) => {
                if (r) {
                  let docs: GroupedDocument[] = this.formGroupedDocumentData(r,
                    app?.DocumentTypes?.length ? app?.DocumentTypes
                    : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()],
                    '',
                  );
                  docs = this.groupStandardCondition(docs, this.application);
                  docs = this.displayRequiredDocumentsOnly(docs);
                  const otherDocs = docs.filter(d => d.otherCondition || (!d?.nonStandardCondition && !d?.standardCondition));
                  const nonStandardConditionDocs = docs.filter(d => d?.nonStandardCondition);
                  const standardConditionDocs = docs.filter(d => d?.standardCondition);
                  const pendingGroups = [
                    ...otherDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
                    ...nonStandardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
                    ...standardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending')
                  ];
                  if (pendingGroups.length) {
                    // do not allow settle loan
                    this.applicationDialogService.openAlertDialog({
                      message: 'Error',
                      subMessage: 'You cannot request loan settlement when you have pending items on the documents tab.'
                    }).afterClosed().subscribe();
                  } else {
                    this.doUpdateApplicationStage('QA');
                  }
                }
              })
            )
          }
        })
      ).subscribe()

    }
  }

  doUpdateApplicationStage(stageName: string, notification = true) {
    if (stageName) {
      this.subscriptions.push(
        this.updateApplicationStageFn({
          salesforceId: this.application.AppInfoSalesforceID ?? "",
          stageName: stageName
        }).pipe(
          this.toastService.spinnerObservable(),
        ).subscribe((response: ApiResponse) => {
          if (response.status) {
            if (notification) {
              this.applicationDialogService.successDialog({
                message: 'Success',
                subMessage: `Application sent to ${stageName} queue`,
              }).afterClosed().subscribe();
            }

            // Application stage needs to refresh on the page
            // This is the best I can do - as updateApplicationStageFn changes the stage in SF, and it takes some time
            // to sync the SF changes to the database. That's why I need to put the setTimeout here
            setTimeout(() => {
              this.getApplicationByIdFn(this.application.ApplicationId).subscribe((application: Application) => {
                this.application = application as AssetFinanceApplication;
              })
            }, 3000);
          } else {
            this.applicationDialogService.openAlertDialog({
              message: 'Error',
              subMessage: response.message,
            }).afterClosed().subscribe();
          }
        })
      )
    }

  }

  doSendAssetAndDisbursementToSf() {
    this.subscriptions.push(
      combineLatest([
        this.getApplicationAssetFn(this.application.ApplicationId),
        this.getDisbursementByApplicationIdFn(this.application.ApplicationId)
      ]).pipe(
        switchMap(([assets, disbursements]: [PpsrAsset[], Disbursement[]]) => {
          // WEB-3702
          // validate asset(s) individual deposit
          const {valid: assetDepositValid, messages} = validateAssetDeposits(assets);
          if (!assetDepositValid) {
            return of ({
              status: false,
              message: messages.join('<br/>')
            })
          }

          // WEB-3702
          // validate asset(s) deposit against application's deposit
          const appDeposit = getDeposit(this.application);
          const {totalDeposit, applicationDeposit, valid: applicationDepositValid} = validateAssetDepositAgainstApplicationDeposit(Number(appDeposit), assets);
          if (!applicationDepositValid) {
            return of ({
              status: false,
              message: `Application deposit $${applicationDeposit} doesn't match with total asset deposit $${totalDeposit}`,
            });
          }

          // validate disbursements
          if (!validateDisbursementData(disbursements)) {
            return of({
              status: false,
              message: "Please make sure you enter payment details for all disbursements."
            })
          }
          console.log(assets, disbursements, this.application.AppInfoSalesforceID ?? "")
          return this.settleLoanFn({
            assets: assets,
            disbursements: disbursements,
            salesforceId: this.application.AppInfoSalesforceID ?? ""
          })
        }),
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response?.status) {
          this.dialogService.successDialog({
            message: "Success",
            subMessage: "Asset and disbursement details sent to Salesforce",
          }).afterClosed().subscribe()
        } else {
          this.dialogService.openAlertDialog({
            message: "Error",
            subMessage: response.message,
          }).afterClosed().subscribe()
        }
        // reload asset table
        this.getApplicationAsset();
      })
    )
  }

  emptyAssetFn($event: boolean) {
    this.isAssetEmpty = $event;
  }

  disableSettleLoan($event: boolean){
    this.disableAddAsset = $event
    this.notAllAssetAccepted = $event
  }

  disableOnPPSRStatus($event: boolean){
    this.notAllAssetAccepted = $event
  }

  getActiveContract() {
    this.subscriptions.push(
      this.getActiveContractForApplicationFn(this.application.ApplicationId)
        .subscribe((r: ContractDetails | null) => {
          this.activeContract = r;
        })
    )
  }

  openGenerateContractDialog() {
    this.subscriptions.push(
      this.dialogService.openGenerateContractDialog({
        sendContractEmailsFn: this.sendContractEmailsFn,
        getRatecardDetailsFn: this.getRatecardDetailsFn,
        getApplicationIndividualsFn: this.getApplicationIndividualsFn,
        generateContractFn: this.generateContractFn,
        getApplicationAssetFn: this.getApplicationAssetFn,
        deleteContractFileFn: this.deleteContractFileFn,
        syncContractDetailsToSfFn: this.syncContractDetailsToSfFn,
        getAccountDetailsFromSfFn: this.getAccountDetailsFromSfFn,
        updateApplicationFn: this.updateApplicationFn,
        getOriginatorBusinessByIdFn: this.getOriginatorBusinessByIdFn,
        application:(this.activatedRoute.snapshot.data as any).application,
        apiUrl: this.apiUrl,
      }).afterClosed().subscribe(() => {
        this.getActiveContract();
      })
    )
  }

  openContractStatusDialog() {
    this.subscriptions.push(
      this.applicationDialogService.openContractStatusDialog({
        getContractStatusFn: this.getContractStatusFn,
        applicationId: this.application.ApplicationId,
        declineContractFn: this.declineContractFn,
        envelopeId: this.activeContract?.envelopeId ?? "",
        resendContractFn: this.resendContractFn,
      }).afterClosed().subscribe(() => {
        this.getActiveContract();
      })
    )
  }

  private displayRequiredDocumentsOnly(docs: GroupedDocument[]) {
    return docs.filter(group => {
      if (
        group.value === constants.documentTypes.internalDocuments.value ||
        group.required || group.docs?.length
      ) {
        return true;
      }
      return false;
    })
  }

  onAssetPricingEvent($event: AssetPricingComponentEvent) {
    this.assetPricingEvents.emit($event);
    if ($event.type === 'asset-pricing-saved' && $event.balloonPercentageDecreased) {
      const currentStage = this.application.InteflowStatusStageName ?? '';
      if (currentStage !== 'Submitted to Credit') {
        this.doUpdateApplicationStage('Submitted to Credit');
      }
    }
  }

  onClick(event: DuplicatedApplication) {
    this.clickApplicationEvent.emit(event);
  }

  refreshCreditTab(event: Application) {
    this.refreshCreditTabEvent.emit(event);
  }
}
